import LockSVG from "@design-system/ui-icons/vanilla/Lock"
import { createIcon } from "../createIcon"

export const LockIcon = createIcon(LockSVG)
